// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	firebase: {
		apiKey: "AIzaSyAWIUjgtFYTu7gnOQcHddfXhoA0Te6sAHA",
		authDomain: "embryo-angular.firebaseapp.com",
		databaseURL: "https://embryo-angular.firebaseio.comx",
		projectId: "embryo-angular",
		storageBucket: "embryo-angular.appspot.comx",
		messagingSenderId: "908846231613",
		appId: "1:908846231613:web:93e1be9ff2aa99739c7a54",
		measurementId: "G-LF0K3VWXS7"
	},
	//url: "http://localhost:56994/",
	url: "https://smcsapi.openclass.ng/",
	schoolId:"a606a2b0-5257-486f-9551-0169cf42aa38" // live
	//schoolId:"aee468f3-6fcc-4e8b-ab44-3ba31e136631"   // test local
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
